import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Shell from '../../../common/components/Shell/Shell';
import WarningComplaintPresenter from './WarningComplaintPresenter';

function WarningComplaintController() {
  const { t, i18n } = useTranslation();
  return (
    <Shell>
      <Grid
        container
        style={{
          maxWidth: 'auto',
          marginLeft: i18n.language == 'en' ? '7.25em' : '',
        }}
      >
        <WarningComplaintPresenter trans={t} i18n={i18n} />
      </Grid>
    </Shell>
  );
}
export default WarningComplaintController;
